import React, { useEffect } from "react";
import CourierCompanyTable from "./CourierCompanyTable";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchCourier,
  fetchCourierOffice,
} from "../../../../redux/features/CourrierSlice";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import { PulseLoader } from "react-spinners";

const CourierCompany = () => {
  const navigate = useNavigate();
  const { currentCourier, courierOffices, loading, agents } = useAppSelector(
    (state) => state.courier
  );
  const { id } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchCourier(id));
    dispatch(fetchCourierOffice({ courierId: id }));
  }, [id, dispatch]);

  const infoCards = [
    {
      title: "Admin",
      borderColor: "border-bgBlue",
      value: loading ? <PulseLoader size={8} color="#2D23A6" /> : "Chika Emeka",
    },
    {
      title: "Agents",
      borderColor: "border-bgBlack",
      value: loading ? (
        <PulseLoader size={8} color="#2D23A6" />
      ) : (
        agents?.data?.items?.length ?? 0
      ),
    },
    {
      title: "Branches",
      borderColor: "border-bgRed",
      value: loading ? (
        <PulseLoader size={8} color="#2D23A6" />
      ) : (
        courierOffices?.data?.totalItems ?? 0
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8">
      <button
        className="text-gray-500 hover:text-gray-800 flex items-center font-bold mb-4 bg-gray-50 p-2 rounded border-2"
        onClick={() => navigate("/courier-management")}
      >
        &larr; Back
      </button>

      {/* Header */}
      <header className="flex items-center justify-between mb-6 flex-wrap gap-2">
        <div className="text-xl sm:text-2xl font-semibold flex gap-2 items-center">
          <img src="/assets/images/svg/company_logo.svg" alt="Company Logo" />
          <span>{currentCourier?.data?.name}</span>
        </div>
      </header>

      {/* Info Cards */}
      <div className="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8">
        {infoCards.map((card, index) => (
          <div
            key={index + 1}
            className={`p-4 bg-white rounded-md border-t-4 shadow-sm ${card.borderColor}`}
          >
            <h4 className="text-xs sm:text-sm md:text-base text-gray-600">
              {card.title}
            </h4>
            <p className="text-xl sm:text-2xl md:text-3xl font-semibold">
              {card.value}
            </p>
          </div>
        ))}
      </div>

      <CourierCompanyTable />
    </div>
  );
};

export default CourierCompany;
